import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import forceLayout from 'helpers/forceLayout';
import SmartLink from 'components/smartLink';
import Img from 'gatsby-image/withIEPolyfill';
import RichText from 'components/richText';
import TextWithBr from 'components/textWithBr';
import styles from './heroProminentText1.module.scss';

export default function HeroProminentText1({
  title,
  subtitle,
  buttonText,
  buttonUrl,
  backgroundImages,
}) {
  const [isLoaded, setIsLoaded] = useState(false);

  /*
   *   Use Effect
   */
  useEffect(() => {
    forceLayout();
    requestAnimationFrame(() => {
      setIsLoaded(true);
    });
  }, [setIsLoaded]);



  /*
   *   Render
   */
  return (
    <section
      className={classnames(styles.container, {
        [styles.loaded]: isLoaded,
        [styles.has_background]: backgroundImages
      })}
    >
      {backgroundImages && <div className={styles.background_image_container}><Img style={{height:'100%', width: '100%'}} className={styles.background_image} fluid={backgroundImages[0].fluid} /></div>}
      <div className={styles.inner}>
        <div className={styles.text}>
          {title && <TextWithBr className={styles.title} tag='h1' content={title} />}
          {buttonText && (
            <SmartLink to={buttonUrl} className={classnames(styles.button, styles.button_desktop)}>
              {buttonText}
            </SmartLink>
          )}
        </div>
        {subtitle && (
            <h2 className={styles.subtitle}>
              <RichText content={subtitle.json} />
            </h2>
          )}
        {buttonText && (
          <SmartLink to={buttonUrl} className={classnames(styles.button, styles.button_mobile)}>
            {buttonText}
          </SmartLink>
        )}  
      </div>
    </section>
  );
}
